import {
    apiRequest,
    riwayatpenugasanDetail,
    riwayatpenugasanUpdate,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/riwayatpenugasanService"

class UpdateRepository {

    fetchRegionCountry = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatpenugasanDetail, {
            params: query
        }, true)
    }

    fetchUpdate = async (query) => {
        return await apiRequest("post", riwayatpenugasanUpdate, {
            body: query
        }, true)
    }
}

export default UpdateRepository